import quickBuyPopupTmpl from '~/js/lib/quick-buy-popup-tmpl';
import { clear, repaint } from '~/js/utils/node';
import debounce from '~/js/utils/debounce';

/**
 * @param {HTMLElement} node - filter element
 * @param {HTMLElement} outputEl - product card container
 */
export function handleCollectionBanners(node, outputEl, viewed) {
  const banners = [...node.querySelectorAll('[data-collection-banner]')];

  if (banners.length) {
    const rows = {
      desktop: viewed / 4,
      mobile: viewed / 2,
    };

    banners.forEach((copy) => {
      const { rowStart } = copy.dataset;
      const start = parseInt(rowStart, 10);

      outputEl.appendChild(copy);
      copy.hidden = false;

      if (start >= rows.mobile) copy.classList.add('!hidden');
      else copy.classList.remove('!hidden');
    });
  }
}

/**
 * @param {HTMLElement} group - group element
 */
export function amountGroups(group) {
  if (!group) return;

  const { drawerType: isMobile } = group.dataset;
  let amountElements = [...group.querySelectorAll('[data-group-amount]')];

  const renderAmount = (amount) => {
    if (isMobile) return amount;
    return amount === 0 ? '' : `(${amount})`;
  };

  if (isMobile) {
    amountElements = [
      ...group
        .parentNode
        .querySelector(`[data-group="${isMobile}"]`)
        .querySelectorAll('[data-group-amount]'),
    ];
  }

  const amount = [...group.querySelectorAll('.is-active')].length;
  const amountText = renderAmount(amount);

  amountElements.forEach((element) => {
    if (isMobile) {
      element.parentNode.hidden = amount <= 0;
    }

    element.textContent = amountText;
  });
}

export function setupQuickBuyPopups(node, products) {
  const popupContainer = node.parentNode.querySelector('[data-popup-container]');

  if (popupContainer) {
    clear(popupContainer);

    let popups = '';

    products.forEach((product) => {
      popups += quickBuyPopupTmpl(product, 'relewise', '');
    });

    popupContainer.innerHTML = popups;
  }
}

export function groupAlphabetically(list) {
  const createLetterTitle = (char) => {
    const el = document.createElement('div');
    const span = document.createElement('span');

    el.classList.add('start-letter');
    el.setAttribute('data-char', char);

    span.innerHTML = char;

    el.prepend(span);

    return el;
  };

  const container = list.querySelector('.filter-container') ?? list;
  const pills = [...container.querySelectorAll('[data-value]')];

  const firstLetters = pills.map((x) => x.dataset.uppercasedValue.charAt(0));
  const uniqueLetters = [...new Set(firstLetters)];

  const first = uniqueLetters
    .map((letter) => pills.find((item) => item.dataset.uppercasedValue.charAt(0) === letter));

  uniqueLetters.forEach((letter) => {
    const uLetter = letter.toUpperCase();
    const letterEl = createLetterTitle(uLetter);

    const firstEl = first.find((el) => el.dataset.uppercasedValue.charAt(0) === uLetter);

    if (container.closest('[data-context-include="mobile-filter-drawers"]')) {
      container.insertBefore(letterEl, firstEl);
    } else {
      firstEl.appendChild(letterEl);
    }
  });
}

export function initGroupSearch(form, groupEl) {
  const allVendorFilterElems = [...groupEl.children];
  const input = form.querySelector('input');

  input.addEventListener('keyup', debounce(() => {
    const query = input.value.toLowerCase();

    allVendorFilterElems.forEach((filterEl) => {
      let filterVal; let
        condition;

      if (filterEl.hasAttribute('data-char')) {
        filterVal = filterEl.dataset.char?.toLowerCase() || '';
        condition = query.length && query.charAt(0) !== filterVal;
      } else {
        filterVal = filterEl.dataset.value?.toLowerCase() || '';
        condition = !filterVal.includes(query);
      }

      if (condition) {
        filterEl.hidden = true;
      } else {
        filterEl.hidden = false;
        repaint(filterEl);
      }
    });
  }), 500);

  form.addEventListener('submit', (e) => e.preventDefault());
}

export function updateProductCount(node, viewed, hits) {
  const amountElem = node.querySelector('[data-filter-amount]');
  const totalElems = node.querySelectorAll('[data-filter-total]');
  const amount = viewed;
  const total = hits;

  if (amountElem) amountElem.textContent = amount;
  if (totalElems.length) totalElems.forEach((elem) => { elem.textContent = total; });
}

// Store drawer filter utils

export function updateStoreHitsCount(facets) {
  const storeDrawer = document.querySelector('.drawer[data-key="collectionStoreDrawer"]');

  if (storeDrawer) {
    const group = document.querySelector('[data-store-filter]');
    const storeFacet = facets?.items?.find((facet) => facet.key === `${window.Shopify.shop}_HasInventory`);

    const available = storeFacet?.available;
    if (!available || !available.length) {
      group.hidden = true;
      return;
    }

    const storeItems = storeDrawer.querySelectorAll('.store-item');

    storeItems.forEach((elem) => {
      const facet = available.find((item) => elem.dataset.name.toLowerCase() === item.value.toLowerCase());
      const label = elem.querySelector('[data-available-label]');

      elem.hidden = !facet;
      if (facet) {
        label.textContent = label.dataset.text.replace('NUMBER', facet.hits);
      }
    });
  }
}

export function selectedStores() {
  return (localStorage.getItem('selectedStores')?.split(',') || []).filter((i) => i.length > 0);
}
